export default {"src":"/_next/static/media/CalendarDate.596b7f30.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};